import {sendChangePassword} from "../../actions/users";
import Input from "../../components/common/input";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";
import {PASSWORD_REQUIREMENTS} from "../../constants";
import UserForm from "../../components/userForm";

const ChangePasswordForm = (props) => {
  const {
  } = props;

  const dispatch = useDispatch();
  const errors = useSelector((state) => state.users.changePasswordErrors);
  const shouldLockForm = false;

  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  return (
    <UserForm
      formTitle="Change Password"
      hideTitle={true}
      submitLabel="Submit"
      submitAction={() => dispatch(sendChangePassword(currentPassword, password, confirmPassword))}
      disabled={shouldLockForm}
    >
      {PASSWORD_REQUIREMENTS}
      <Input
        name='currentPassword'
        id='currentPassword'
        label='Current Password'
        type='password'
        value={currentPassword}
        changeAction={setCurrentPassword}
        disabled={shouldLockForm}
        errors={errors?.currentPassword}
        focusOnError={errors?.currentPassword}
      />
      <Input
        name='password'
        id='password'
        label='New Password'
        type='password'
        value={password}
        changeAction={setPassword}
        disabled={shouldLockForm}
        errors={errors?.password}
        focusOnError={errors?.password}
      />
      <Input
        name='confirmPassword'
        id='confirmPassword'
        label='Confirm New Password'
        type='password'
        value={confirmPassword}
        changeAction={setConfirmPassword}
        disabled={shouldLockForm}
        errors={errors?.confirmPassword}
        focusOnError={errors?.confirmPassword}
      />
    </UserForm>
  );
}

export default ChangePasswordForm;